export const CANADIAN_PROVINCE_OPTIONS = Object.freeze([
    Object.freeze({ value: 'AB', label: 'Alberta' }),
    Object.freeze({ value: 'BC', label: 'British Columbia' }),
    Object.freeze({ value: 'MB', label: 'Manitoba' }),
    Object.freeze({ value: 'NB', label: 'New Brunswick' }),
    Object.freeze({ value: 'NL', label: 'Newfoundland and Labrador' }),
    Object.freeze({ value: 'NS', label: 'Nova Scotia' }),
    Object.freeze({ value: 'NT', label: 'Northwest Territories' }),
    Object.freeze({ value: 'NU', label: 'Nunavut' }),
    Object.freeze({ value: 'ON', label: 'Ontario' }),
    Object.freeze({ value: 'PE', label: 'Prince Edward Island' }),
    Object.freeze({ value: 'QC', label: 'Quebec' }),
    Object.freeze({ value: 'SK', label: 'Saskatchewan' }),
    Object.freeze({ value: 'YT', label: 'Yukon' }),
]);

const CANADIAN_PROVINCE_CODES = new Set(
    CANADIAN_PROVINCE_OPTIONS.map(({ value }) => value)
);

const POSTAL_PREFIX_PROVINCES = Object.freeze({
    A: ['NL'],
    B: ['NS'],
    C: ['PE'],
    E: ['NB'],
    G: ['QC'],
    H: ['QC'],
    J: ['QC'],
    K: ['ON'],
    L: ['ON'],
    M: ['ON'],
    N: ['ON'],
    P: ['ON'],
    R: ['MB'],
    S: ['SK'],
    T: ['AB'],
    V: ['BC'],
    X: ['NT', 'NU'],
    Y: ['YT'],
});

const CANADIAN_POSTAL_CODE_PATTERN =
    /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z]\s?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

export function normalizeCanadianPostalCode(value) {
    const compact = String(value || '').trim().toUpperCase().replace(/\s+/g, '');
    if (compact.length <= 3) return compact;
    return `${compact.slice(0, 3)} ${compact.slice(3)}`;
}

export function isCanadianProvince(value) {
    return CANADIAN_PROVINCE_CODES.has(String(value || '').trim().toUpperCase());
}

export function validateCanadianPostalCode(value, province) {
    const normalized = normalizeCanadianPostalCode(value);
    if (!CANADIAN_POSTAL_CODE_PATTERN.test(normalized)) return false;
    if (!province) return true;

    const provinceCode = String(province).trim().toUpperCase();
    return POSTAL_PREFIX_PROVINCES[normalized.charAt(0)]?.includes(provinceCode) === true;
}
